module.exports = __webpack_public_path__ + "static/media/proposed_hero.83cd54bf.jpg";